<template>
    <div class="relative w-full">
        <input class="form-input border-2 focus:border-green block w-full"
               :class="{'h-10': mobile}"
               ref="input"
               type="text"
               :min="min"
               :max="max"
               :type="type"
               v-model="currentValue"
               v-bind="$attrs"
        >
        <button type="button" class="absolute top-0 right-0 h-full flex items-center pr-4" @click="toggleDatepicker">
            <calendar-icon class="w-6 text-red"/>
        </button>
    </div>
</template>
<script>
import {isMobile} from "../functions";
import CalendarIcon from './icons/Calendar'

export default {
    components: {
        CalendarIcon
    },
    inheritAttrs: false,
    props: {
        min: String,
        max: String,
        value: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            datepicker: null,
            type: 'date',
            mobile: isMobile(),
            currentValue: this.value,
        }
    },
    mounted() {
        if (this.mobile) {
            this.type = 'date';
            return;
        }

        this.type = 'text';

        Promise.all([
            import('pikaday'),
            import('dayjs'),
            import('dayjs/plugin/customParseFormat')
        ]).then((modules) => {
            let today = new Date();
            let {default: Pikaday} = modules[0];
            let {default: dayjs} = modules[1];
            dayjs.extend(modules[2].default);

            this.datepicker = new Pikaday({
                firstDay: 1,
                keyboardInput: false,
                minDate: new Date(this.min),
                maxDate: new Date(this.max),
                yearRange: [today.getFullYear() - 100, today.getFullYear() + 1],
                format: 'DD.MM.YYYY',
                field: this.$refs.input,
                i18n: this.$tm('datepicker'),
                parse(value, format) {
                    if (typeof value !== 'string') {
                        return value;
                    }
                    return new Date(dayjs(value, ['DD.MM.YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD'));
                },
                toString(date, format) {
                    return dayjs(date).format(format);
                }
            });
        });
    },
    methods: {
        toggleDatepicker() {
            if (this.type === "date") {
                this.$refs.input.focus();
                return;
            }
            if (this.datepicker.isVisible()) {
                this.datepicker.hide();
            } else {
                this.datepicker.show();
            }
        }
    }
}
</script>
